<mat-card (click)="handleClick()" [ngClass]="{ 'selected': selected }" class="cursor-pointer">
    <mat-card-header mat-card-title-group class="w-full flex items-center justify-between gap-2">
        <img mat-card-avatar [src]="item.avatarUrl" />
        <div class="flex flex-col flex-grow">
            <mat-card-title class="truncate">{{ item.title }}</mat-card-title>
            <mat-card-subtitle *ngIf="item.subtitle" class="truncate">CPF: {{ item.subtitle }}</mat-card-subtitle>
        </div>
        <mat-icon class="w-6 h-6" svgIcon="angle-right-b"></mat-icon>
    </mat-card-header>
</mat-card>